"use client";

import _objectSpread from "/Users/michaelwilder/Desktop/Code/Docket/docket-frontend-firebase/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/michaelwilder/Desktop/Code/Docket/docket-frontend-firebase/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import { useContext } from 'react';
import useEventCallback from '@restart/hooks/useEventCallback';
import CloseButton from './CloseButton';
import ModalContext from './ModalContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AbstractModalHeader = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$closeLabel = _ref.closeLabel,
    closeLabel = _ref$closeLabel === void 0 ? 'Close' : _ref$closeLabel,
    closeVariant = _ref.closeVariant,
    _ref$closeButton = _ref.closeButton,
    closeButton = _ref$closeButton === void 0 ? false : _ref$closeButton,
    onHide = _ref.onHide,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["closeLabel", "closeVariant", "closeButton", "onHide", "children"]);
  var context = useContext(ModalContext);
  var handleClick = useEventCallback(function () {
    context == null || context.onHide();
    onHide == null || onHide();
  });
  return /*#__PURE__*/_jsxs("div", _objectSpread({
    ref: ref
  }, props, {
    children: [children, closeButton && /*#__PURE__*/_jsx(CloseButton, {
      "aria-label": closeLabel,
      variant: closeVariant,
      onClick: handleClick
    })]
  }));
});
export default AbstractModalHeader;